import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import "../css/template_custom.css";
import "../css/template_menu.css";
import "../libs/menu_js.js";
import Header from '../components/Header';

const ClientLayout = ({ children }) => {
  useEffect(() => {
    var menuClass = sessionStorage.getItem('menu_class');
    if (!menuClass) menuClass = 'nav-md';
    document.body.classList.add(menuClass);
  }, []);
  const location = useLocation();
  const getClassActive = (source) => {
    var list = source.split('/');
    const pagePath = location.pathname.replace(/^\/|\/$/g, '');

    if (list.includes(pagePath)) return 'active';
    if (list.includes(pagePath + location.search)) return 'active';
    return '';
  };
  return (
    <div className="web-cover1">
      <Header />
      <div className="web-main bg-white">
        {children}
      </div>
    </div>
  );
};

export default ClientLayout;